import {
  createStandardAction,
  createReducer,
  ActionType,
  StateType
} from "typesafe-actions";

export type DeviceActionType = "SET_TOGGLE";
type TogglePayload = { key: string; value: boolean };

export const setToggle = createStandardAction("SET_TOGGLE")<TogglePayload>();

const DeviceActions = { setToggle };
export type DeviceAction = ActionType<typeof DeviceActions>;

export type deviceSettings = {
  displayIconsInCall: boolean;
  enableAudioOnlyCalls: boolean;
  enableJoinAndLeaveTones: boolean;
  enableHDMI: boolean;
  enableAppleAirplay: boolean;
  enablePolyContent: boolean;
  pictureInPicture: boolean;
  sleepDisplay: boolean;
  autoHideTopInfo: boolean;
};

export const defaultDeviceState: { [index: string]: any } = {
  displayIconsInCall: false,
  enableAudioOnlyCalls: true,
  enableJoinAndLeaveTones: false,
  enableHDMI: true,
  enableAppleAirplay: true,
  enablePolyContent: false,
  pictureInPicture: true,
  sleepDisplay: false,
  autoHideTopInfo: false
};

export const DeviceReducer = createReducer(defaultDeviceState).handleAction(
  setToggle,
  (state, action) => ({
    ...state,
    [action.payload.key]: action.payload.value
  })
);
export type DeviceState = StateType<typeof DeviceReducer>;
